<template>
	<div class="member-panel" :class="isAvailable(member)" @click="toggleDetails($event)">
		<div class="member-name">
    {{ nextAvailableDate(member) }}
		<b class="nameLink" @click="goToMember(member)">{{ member.first }} {{ member.last }}</b>,

			<b>{{ memberLabelPrefix(member) }}</b><b :style="{ color: 'red' }"><i>{{ memberLabelEngagement(member)
					}}</i></b><b>{{ memberLabelEngagementSeparator(member) }}</b><b :style="{ color: 'red' }">{{
						Array.isArray(member.account_owner) && member.account_owner.length > 0 ? member.account_owner.join(", ")
							: "" }}</b><b>{{ memberLabelSuffix(member) }},</b>
			{{ member.city }} {{ member.state }},
			{{
				member.roles.length > 0 && member.roles[0].trim() != ""
					? `${member.roles}, `
					: ""
			}}{{ member.organization }}
    <a v-if="member.linkedIn" :href="member.linkedIn" target="_blank">
        <img class="li-small"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Linkedin_icon.svg/1200px-Linkedin_icon.svg.png" />
    </a>&nbsp;&nbsp;

    <div v-if="!ask.recommendedAdvisors.includes(member._id)" class="add-match" id="addmatchbutton"
        @click="addAdvisor(member)">
        +Add
    </div>
    <div v-if="ask.recommendedAdvisors.includes(member._id)" class="remove-match" id="removematchbutton"
        @click="removeAdvisor(member)">
        Remove
    </div>
    <div class="score memberTotalScores">
        {{ member.matchDetails.totalScore }}
    </div>
</div>

		<span v-for="strategy in member.matchDetails.selectionStrategies" :key="member._id + strategy[0]">
			<clicker mode="dice"
			v-if="strategy[2] && strategy[2] > 0"
			style="float:right"
			:value="strategy[2]"
			:color="getDotColor(strategy[0])"
			:title="strategy[0]"></clicker>
			<b
				v-if="!(strategy[2] && strategy[2] > 0)"
				class="strategy-dot"
				:title="strategy"
				:style="`float:right; color:#${getDotColor(strategy[0])}`"
				>⬤</b>
		</span>

		<!-- Matched terms -->
		<div class="matched-terms">
			<div
					 class="tagged-term"
					 v-for="(match, idx) in matchedTags"
					 :key="match + idx"
					 :style="`color:${match.dimension.color};`">
				{{ match.tag}}
			</div>
		</div>
		<div>
			{{ member.major1}}, {{ member.department1}} {{ member.school1}}
			{{ member.year1}}. {{ member.circles ? member.circles.join(",") : "" }}
			<div style="float: right">{{ statusLine()}}</div>
		</div>
		<!-- More details -->
		<div v-if="showDetails" class="unmatched-terms">
			<div
					 class="small-term"
					 v-for="term in member.matchDetails.matchTerms"
					 :key="term">
				{{ term}} /
			</div>
			<div
					 class="small-term"
					 v-for="(match, idx) in unmatchedTags"
					 :key="match + idx"
					 :style="`color:${match.dimension.color};`"
					 @click="addTerm(match)">
				{{ match.tag}}
			</div>
		</div>
	</div>
</template>

<script>
import API from "@/services/API";
import '@/components/gemini/styles.css';
import Clicker from '@/components/gemini/Clicker.vue';
import Config from '@/utils/config';
export default {
	name: 'TinyAdvisor',
	props: ["member", "ask"],
	components: {
		Clicker
	},
	data() {
		return {
			api: new API(),
			colors: ["006ba6", "70d6ff", "b6af6d", "1a535c", "badca1", "ea9770", "ffd670", "6a2317", "ca1bad", "3f0dc4", "fecda4", "2bff70", "ff7006", "008800", "ff0000", "654321", "789abc", "165f9d"],
			dimensions: [],
			matchedTags: [],
			unmatchedTags: [],
			showDetails: false
		}
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData: async function () {
			Config.GEMINI_DIMENSIONS.forEach((dim) => {
				this.addDimension(dim.name, dim.color);
			});
			for (let dim of this.dimensions) {
				let intersection = this.member.dimensions[dim.name].filter(x => this.ask.matchingCriteria.dimensions.find(d => d.name == dim.name).terms.some(mc => mc.term == x.trim()));
				for (let t = 0; t < intersection.length; t++) {
					this.matchedTags.push({
						tag: intersection[t],
						dimension: dim
					})
				}
			}
			if (process.env.NODE_ENV == 'local' || process.env.NODE_ENV == 'dev') {
				$('.memberTotalScores').show();
			}
		},
		addDimension(name, color) {
			this.dimensions.push({
				name: name,
				color: color,
				imageURL: `../../../static/${name}.png`,
				results: []
			});
		},
		isAvailable: function (member) {
			if (member.pendingAskFlag) return "pending"
			if (member.nextEngagementDate) {
				let engagementDate = new Date(member.nextEngagementDate)
				let response = engagementDate < new Date() ? "available":"unavailable";
				return response
			} else {
				return "available"
			}
			//else if (!member.pendingAskFlag) return "unavailable"
			//return "available"
			//if (!member.nextEngagementDate || (member.nextEngagementDate && new Date(member.nextEngagementDate) < new Date() && !member.pendingAskFlag)) return "available";
		},
		nextAvailableDate: function (member) {
			if (member.nextEngagementDate) {
				let d = new Date(member.nextEngagementDate)
				return `(${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear() - 2000})`;
			} else {
				return "";
			}
		},
		getDotColor: function (strategy) {
			let idx = this.ask.matchingCriteria.selectionStrategies.findIndex(s => s[0].toUpperCase() == strategy.toUpperCase());
			return this.colors[idx];
		},
		getDiceValue: function (strategy) {
			let ss = this.ask.matchingCriteria.selectionStrategies.find(s => s[0].toUpperCase() == strategy.toUpperCase());
			return ss[2];
		},
		addAdvisor: async function (member) {
			if (this.ask.recommendedAdvisors.indexOf(member._id) === -1) {
				this.ask.recommendedAdvisors.push(member._id);
				this.saveAdvisors();
			}
		},
		removeAdvisor: async function (member) {
			this.ask.recommendedAdvisors.splice(this.ask.recommendedAdvisors.indexOf(member._id), 1);
			this.saveAdvisors();
		},
		goToMember(member) {
			window.open(`/members/${member._id}`, "_blank");
		},
		saveAdvisors: function () {
			this.api.post(`asks/${this.ask._id}/match`, {advisors: this.ask.recommendedAdvisors}).then(response => {
				console.log("Matched advisors saved")
			});
		},
		addTerm: async function (term) {
			this.$eventHub.$emit('gemini-add-term', term);
		},
		statusLine: function () {
			let line = !this.member.requestReceived.lastRequestReceived ? "" : `Last request: ${this.tinyDate(this.member.requestReceived.lastRequestReceived)}`;
			line += !this.member.response.lastResponse ? "" : `, response: ${this.tinyDate(this.member.response.lastResponse)}`;
			line += ` (${this.member.response.totalResponse}/${this.member.requestReceived.totalRequestReceived})`
			line += `. Prefers ${this.member.frequency} `;
			return line;
		},

		toggleDetails: async function ($event) {
			//don't open advisor if the add/remove buttons are clicked.
			if ($event.target.id == 'addmatchbutton' || $event.target.id == 'removematchbutton') {return }
			this.showDetails = !this.showDetails;
			if (this.showDetails) {
				this.unmatchedTags = [];
				for (let i = 0; i < this.dimensions.length; i++) {
					let dim = this.dimensions[i];
					let outersection = this.$lodash.reject(this.member.dimensions[dim.name], x => this.ask.dimensions[dim.name].includes(x));
					for (let t = 0; t < outersection.length; t++) {
						this.unmatchedTags.push({
							tag: outersection[t],
							dimension: dim
						})
					}
				}
			}
		},
		memberLabelPrefix(member) {
			const parts = [];
			if (member.capacity && member.capacity !== "N/A") parts.push(member.capacity);
			const hasEngagement = !!member.engagement;
			const hasOwner = Array.isArray(member.account_owner) && member.account_owner.length > 0;
			const hasAnything = parts.length > 0 || hasEngagement || hasOwner;
			if (!hasAnything) return "";
			return `(${parts.join(", ")}${parts.length > 0 && (hasEngagement || hasOwner) ? ", " : ""}`;
		},
		memberLabelSuffix(member) {
			const hasOwner = Array.isArray(member.account_owner) && member.account_owner.length > 0;
			const hasPrefix = (member.capacity && member.capacity !== "N/A") || member.engagement;
			return hasOwner || hasPrefix ? ")" : "";
		},
		tinyDate: function (dt) {
			const d = new Date(dt);
			return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear() - 2000}`;
		},
		memberLabelEngagement(member) {
			return member.engagement || "";
		},
		memberLabelEngagementSeparator(member) {
			const hasEngagement = !!member.engagement;
			const hasOwner = Array.isArray(member.account_owner) && member.account_owner.length > 0;
			return hasEngagement && hasOwner ? ", " : "";
		},
	}
}
</script>

<style scoped>
.member-panel {
	border-radius: 5px;
	margin: 2px 0px 2px 0px;
	padding: 3px;
	clear: both;
	overflow: auto;
}

.available {
	border: 2px solid green;
}

.unavailable {
	color: #aaaaaa;
	background-color: #f2f2f2;
	border: 1px dotted red;
	font-style: italic;
}

.pending {
	color: #aaaaaa;
	background-color: LightYellow;
	border: 1px dotted orange;
	font-style: italic;
}

.nameLink {
	cursor: pointer;
}

.li-small {
	display: inline-block;
	vertical-align: center;
	height: 16px;
}

.add-match {
	color: green;
	text-decoration: underline;
	margin: 0px 10px 0px 0px;
	float: right;
	cursor: pointer;
}

.remove-match {
	color: maroon;
	text-decoration: underline;
	margin: 0px 10px 0px 0px;
	float: right;
	cursor: pointer;
}

.score {
	float: right;
	margin: 0px 10px 0px 0px;
	font-size: 18px;
}

.matched-terms {
	display: flex;
	flex-wrap: wrap;
}

.unmatched-terms {
	display: flex;
	flex-wrap: wrap;
	line-height: 80%;
}

.tagged-term {
	text-decoration: underline;
	font-weight: 600;
	margin: 0px 5px 3px 0px;
	cursor: pointer;
}

.small-term {
	text-decoration: underline;
	margin: 0px 5px 3px 0px;
	cursor: pointer;
	font-size: 14px;
	line-height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/gemini/TinyAdvisor.vue